module.exports = __webpack_public_path__ + "static/media/vegitables_23.976779a2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_23.csv
// module id = 606
// module chunks = 0